import alas, { status } from '@/alas';
import { defineComponent, onMounted, ref, computed } from '@vue/composition-api';
export default defineComponent({
    props: ['type'],
    setup(props, context) {
        // ================
        //
        // refs
        //
        let types = ref(status.fetch('types'));
        let typeModel = ref(alas.make('crop', 'type'));
        // ================
        //
        // refs
        //
        let eventTypes = computed(() => {
            let output = new Set();
            let typeCount = {};
            for (let item of typeModel.value.events.items) {
                if (item.enable) {
                    output.add(item.type);
                    if (typeCount[item.type] == null) {
                        typeCount[item.type] = 0;
                    }
                    typeCount[item.type] += 1;
                }
            }
            return [...output].sort((a, b) => typeCount[a] > typeCount[b] ? -1 : 1);
        });
        // ================
        //
        // mounted
        //
        onMounted(() => {
            types.value.o.fetch.seek().then(() => {
                typeModel.value = types.value.fetch(props.type);
            });
        });
        // ================
        //
        // methods
        //
        let selectEvent = event => context.emit('select', event);
        // ================
        //
        // done
        //
        return {
            types,
            typeModel,
            eventTypes,
            selectEvent
        };
    }
});
